module.exports = "//public.zight.com/packs/media/images/star_active-2c2072249f540a00a1eb2fe9026b22cf.svg";